export const THUONG_HIEU_PERMISSION_CODES = {
  WEB_BH_THUONG_HIEU_LIST: 'WEB_BH_THUONG_HIEU_LIST',
  WEB_BH_THUONG_HIEU_ADD: 'WEB_BH_THUONG_HIEU_ADD',
  WEB_BH_THUONG_HIEU_EDIT: 'WEB_BH_THUONG_HIEU_EDIT',
  WEB_BH_THUONG_HIEU_DELETE: 'WEB_BH_THUONG_HIEU_DELETE',
  WEB_BH_THUONG_HIEU_IMPORT: 'WEB_BH_THUONG_HIEU_IMPORT',
  WEB_BH_THUONG_HIEU_EXPORT: 'WEB_BH_THUONG_HIEU_EXPORT',
} as const
